module.exports = __webpack_public_path__ + "static/template-home-about-hero-background-370aa57e98b293467d9c9ce3327f6001.jpg";